import React, { PropsWithChildren, useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { Drawer } from '../../core/stores/drawer';
import { uiStore } from '../../core/stores/ui-store';

import styles from './contextual-drawer.module.scss';
export const ContextualDrawer: React.FC<PropsWithChildren> = observer(({ children }) => {
  useEffect(() => {
    uiStore.contextDrawer = new Drawer();

    return () => {
      uiStore.contextDrawer = undefined;
    };
  }, []);

  return (
    <div className={styles['container']} data-is-closed={!uiStore.contextDrawer?.isOpen}>
      {children}
    </div>
  );
});
